/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientLegalEntityBillingInformationAddressUpdateRequest } from './';
import {
    ClientLegalEntityBillingInformationAddressUpdateRequestFromJSON,
    ClientLegalEntityBillingInformationAddressUpdateRequestFromJSONTyped,
    ClientLegalEntityBillingInformationAddressUpdateRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientLegalEntityBillingInformationUpdateRequest
 */
export interface ClientLegalEntityBillingInformationUpdateRequest {
    /**
     * 
     * @type {ClientLegalEntityBillingInformationAddressUpdateRequest}
     * @memberof ClientLegalEntityBillingInformationUpdateRequest
     */
    address: ClientLegalEntityBillingInformationAddressUpdateRequest;
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationUpdateRequest
     */
    legalName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationUpdateRequest
     */
    vatNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationUpdateRequest
     */
    registrationOfficeInformation?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLegalEntityBillingInformationUpdateRequest
     */
    registrationNumber: string;
}

/**
 * Check if a given object implements the ClientLegalEntityBillingInformationUpdateRequest interface.
 */
export function instanceOfClientLegalEntityBillingInformationUpdateRequest(value: object): value is ClientLegalEntityBillingInformationUpdateRequest {
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('legalName' in value) || value['legalName'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    return true;
}

export function ClientLegalEntityBillingInformationUpdateRequestFromJSON(json: any): ClientLegalEntityBillingInformationUpdateRequest {
    return ClientLegalEntityBillingInformationUpdateRequestFromJSONTyped(json, false);
}

export function ClientLegalEntityBillingInformationUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientLegalEntityBillingInformationUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'address': ClientLegalEntityBillingInformationAddressUpdateRequestFromJSON(json['address']),
        'legalName': json['legalName'],
        'vatNumber': json['vatNumber'] == null ? undefined : json['vatNumber'],
        'registrationOfficeInformation': json['registrationOfficeInformation'] == null ? undefined : json['registrationOfficeInformation'],
        'registrationNumber': json['registrationNumber'],
    };
}

export function ClientLegalEntityBillingInformationUpdateRequestToJSON(value?: ClientLegalEntityBillingInformationUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'address': ClientLegalEntityBillingInformationAddressUpdateRequestToJSON(value['address']),
        'legalName': value['legalName'],
        'vatNumber': value['vatNumber'],
        'registrationOfficeInformation': value['registrationOfficeInformation'],
        'registrationNumber': value['registrationNumber'],
    };
}

